import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconProvider } from "@ant-design/icons";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { App, ConfigProvider, notification } from "antd";
import hljs from "highlight.js";
import { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Helmet } from "react-helmet";
import { Router as RealAdminRouterProvider } from "./components/route/router.js";
import { config } from "./config/config.js";
import { createQueryClient } from "./others/react-query.js";
import { RootStore } from "./store/root.js";
import { colors } from "./styles/colors.js";
/**
 * Always import latest
 */ import "antd/dist/reset.css";
import "./styles/index.scss";
// highlight.js is used by quill-editor-wrapper component
hljs.configure({
    languages: [
        "javascript"
    ]
});
/**
 * As the antd notifications are a global function we also need to define our prefix at a global context.
 */ // eslint-disable-next-line internal-rulesdir/no-disallowed-import-method
notification.config({
    prefixCls: process.env.ANTD_PREFIX,
    top: 80
});
createRoot(document.getElementById("root")).render(/*#__PURE__*/ _jsx(Suspense, {
    fallback: null,
    children: /*#__PURE__*/ _jsx(ConfigProvider, {
        prefixCls: process.env.ANTD_PREFIX,
        iconPrefixCls: `${process.env.ANTD_PREFIX}-anticon`,
        tag: {
            variant: "outlined"
        },
        theme: {
            token: {
                colorPrimary: colors.ci.devowlBlue,
                borderRadius: 2
            },
            components: {
                Button: {
                    colorPrimaryHover: colors.ci.devowlBlueHover
                },
                Modal: {
                    colorBorderBg: colors.main.background,
                    colorFillContent: colors.main.background,
                    contentBg: colors.main.background,
                    headerBg: colors.main.background
                }
            }
        },
        children: /*#__PURE__*/ _jsx(IconProvider, {
            value: {
                prefixCls: `${process.env.ANTD_PREFIX}-anticon`
            },
            children: /*#__PURE__*/ _jsx(App, {
                message: {
                    top: 50
                },
                children: /*#__PURE__*/ _jsx(RootStore.StoreProvider, {
                    children: /*#__PURE__*/ _jsxs(QueryClientProvider, {
                        client: createQueryClient(),
                        children: [
                            /*#__PURE__*/ _jsx(Helmet, {
                                defaultTitle: config.htmlMeta.defaultTitle,
                                titleTemplate: config.htmlMeta.titleTemplate
                            }),
                            /*#__PURE__*/ _jsx(RealAdminRouterProvider, {}),
                            /*#__PURE__*/ _jsx(ReactQueryDevtools, {})
                        ]
                    })
                })
            })
        })
    })
}));
